/**
 * Config Versions API client.
 *
 * 对接后端 `/system/config/versions` 端点（详见 OpenSpec add-version-based-cache）。
 *
 * 响应 key 形式：
 *   "listings:tenant:100"               — tenant-scoped 资源
 *   "watchlist:tenant:100:user:42"      — user-scoped 资源
 *   "lookup_tables:global"              — 全局共享资源
 * value 始终为毫秒时间戳字符串（前端只需 `===` 比较，不要 parseInt）。
 */

import axios from 'axios'

export type ConfigVersions = Record<string, string>

// 全局响应拦截器（src/api/axios-config.ts）已经把 AxiosResponse unwrap 成 body
// 本身（{code,data} 信封会被剥一层；扁平 body 原样返回）。所以 `await axios.x(...)`
// 拿到的就是后端 body，再读 `.data` 会拿到 undefined。这里用 unknown 绕开 axios
// 的 AxiosResponse 类型，让函数签名反映 runtime 实际形状。
export const configVersionsApi = {
  /**
   * 拉取当前用户可见的所有资源版本号 map。tenant + user-scoped + global 都返回。
   */
  async getVersions(): Promise<ConfigVersions> {
    return (await axios.get('/system/config/versions')) as unknown as ConfigVersions
  },

  /**
   * Admin 手动 bump 一个资源的版本号（运维 / 迁移脚本兜底）。
   */
  async bumpVersion(payload: {
    resource: string
    scope?: 'tenant' | 'user' | 'global'
    tenantId?: string
    userId?: string
  }): Promise<{ resource: string; scope: string; version: string }> {
    return (await axios.post('/system/config/versions/bump', payload)) as unknown as {
      resource: string
      scope: string
      version: string
    }
  },
}
